import { render, staticRenderFns } from "./index-property-new.vue?vue&type=template&id=a3fd4a90&scoped=true"
import script from "./index-property-new.vue?vue&type=script&lang=js"
export * from "./index-property-new.vue?vue&type=script&lang=js"
import style0 from "./index-property-new.vue?vue&type=style&index=0&id=a3fd4a90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fd4a90",
  null
  
)

export default component.exports